// Changelog entries for the application
// Each entry represents a version update with its changes
// Entries are displayed in the ChangelogModal when user hasn't seen them yet
// Format: version, date, and array of changes

export const CHANGELOGS = [
  {
    version: "v1.0.8",
    date: "12 November 2025",
    changes: [
      "Inspection drafts are more reliable – saving, editing and resuming drafts works more smoothly.",
      "Vehicle search in inspections is more flexible and finds registrations more accurately.",
      "Login is now restricted to users who have PWA access enabled, for better access control.",
      "Push notifications are now initialised on login, improving reliability of alerts.",
      "Improved app auto-update behaviour so you get new versions more consistently.",
      "Various fixes to inspection images, maps and modals to make the app feel more stable."
    ]
  },
  {
    version: "v1.0.7",
    date: "31 October 2025",
    changes: [
      "Added a breakdown map with Google Maps, showing breakdowns and mechanics with easy navigation to Google Maps.",
      "Mechanic markers and locations on the map are more accurate and stay visible when the screen updates.",
      "Drivers now have a Panic button tile on the dashboard, with clear loading and disabled states while a panic is active.",
      "Inspection creation has a cleaner, step-by-step flow with improved styling and template search.",
      "Amber and red inspection badges now prompt for mandatory photos and comments where needed.",
      "General layout and spacing improvements so dashboards and maps display more consistently."
    ]
  },
  {
    version: "v1.0.6",
    date: "6 October 2025",
    changes: [
      "Added On Duty trigger to mark mechanic as on duty",
      "Added Location button when on duty to update mechanic location"
    ]
  },
  {
    version: "v1.0.5",
    date: "25 September 2025",
    changes: [
      "Dashboard reorganized for smoother navigation",
      "Breakdown history now visible directly on the dashboard",
      "New management view to oversee breakdowns",
      "Please restart the app to apply these changes"
    ]
  },
  {
    version: "v1.0.4",
    date: "26 August 2025",
    changes: [
      "Introduced Inspections module",
      "Save inspection as Draft and resume",
      "Capture user location (latitude/longitude) on submit of inspection"
    ]
  },
  {
    version: "v1.0.3",
    date: "20 August 2025",
    changes: [
      "Added Breakdown Request functionality",
      "Added Assign Mechanic to controller workflow in Breakdown Wizard"
    ]
  },
  {
    version: "v1.0.1",
    date: "10 July 2025",
    changes: [
      "Added new About page with app information",
      "Improved user interface for breakdown details",
      "Enhanced user profile display",
      "Added better error handling for API requests",
      "Added breakdown history display",
      "Added breakdown status changes",
      "Added breakdown completion for mechanics",
    ]
  },
  {
    version: "v1.0.0",
    date: "1 July 2025",
    changes: [
      "Initial release of RNR Mobile for mechanics",
      "Dashboard with breakdown overview",
      "Breakdown details view",
      "User profile display",
      "Call RNR support functionality"
    ]
  }
  // Add new changelog entries at the TOP of this array
  // This ensures the newest changes are shown first
];
